// import './graph-3d.css';
import drawNode from './draw-node.js';
import processData from './process-data.js';
import cutToNode from './graph-action.js';
import Earth from './earth-3d/earth-3d.js';
import { colorUtil } from "./color-util.js";
import nodeImg from '../../../static/img/3d/golf.jpeg';
import theme from '../../utils/theme-3d.js';

let defaultConfig = {
    dom: document.body,
    data: { nodes: [], links: [] },
    eventBus: {}, // 或者函数通信也可以
};

let graph3d = class {
    constructor({ dom, data, eventBus, rootId } = defaultConfig) {
        this.drawNode = drawNode.bind(this);
        this.processData = processData.bind(this);
        this.cutToNode = cutToNode.bind(this);
        this.init(dom, data, eventBus, rootId);
    }
    init(dom, data, eventBus, rootId) {
        // 参数变量
        this.dom = dom;
        this.data = data;
        this.eventBus = eventBus;
        this.rootId = rootId;
        this.colorKey = 'color_key_3d';
        this.processData(this);
        $l(this.data);
        this.theme = theme[window.$qsObj.theme] || theme.default;

        // 3D图谱变量
        this.Graph = ForceGraph3D({ controlType: 'orbit' })(this.dom);
        // this.Graph = ForceGraph3D()(this.dom);

        this.renderer = this.Graph.renderer();
        this.renderer.logarithmicDepthBuffer = true;

        this.scene = this.Graph.scene();
        this.camera = this.Graph.camera();
        this.controls = this.Graph.controls();
        this.scene.fog = new THREE.Fog(0x000000, 0, 4000);
        // 业务变量 不用的都放到子文件里

        window.camera = this.camera;
        window.renderer = this.renderer;
        window.controls = this.controls;

        this.initGraph3d(); // 基础功能初始化

        this.initForce(); // 力学模型初始化
        this.initLink(); // 边类型初始化
        this.initEvent(); // 事件初始化
        this.initControls();

        setTimeout(() => {
            this.earth = new Earth(this.renderer, this.scene, this.camera, this.theme);
            this.eventBus.$emit('3d-action-start');
        }, 1000);

        this.nodeTexture = new THREE.TextureLoader().load(nodeImg);
        this.nodeTexture.repeat.set(4, 2);
        this.nodeTexture.wrapS = this.nodeTexture.wrapT = THREE.RepeatWrapping;
        this.nodeTexture.anisotropy = 16;
        this.nodeTexture.needsUpdate = true;
        drawNode(this); // 节点绘制

        this.render();

        window.addEventListener('resize', this.onResize, false);
    }
    initControls() {
        this.controls.maxDistance = 3000;
        this.controls.autoRotate = true;
        this.controls.autoRotateSpeed = -1.0;
    }

    onResize() {
        if (window.camera && window.controls && window.renderer) {
            window.camera.aspect = window.innerWidth / window.innerHeight;
            window.camera.updateProjectionMatrix();
            window.controls.update();
            window.renderer.setSize(window.innerWidth, window.innerHeight);
        }
    }

    async showGoldParticle() {
        // this.nodesChild.parent.visible = false;
        this.changeNodesOpacity(0.1);
        if (!this.earth || !this.earth.goldParticles) {
            return;
        }
        this.earth.goldParticles.visible = true;

        // 复原最初的粒子位置
        // let initialPositions = this.earth.goldParticles.geometry.attributes.initialPosition;
        // let total = this.earth.goldParticles.geometry.attributes.position.count;
        // let position = this.earth.goldParticles.geometry.attributes.position;
        // for (let j = 0; j < total; j++) {
        //     let px = initialPositions.getX( j );
        //     let py = initialPositions.getY( j );
        //     let pz = initialPositions.getZ( j );
        //     position.setXYZ(j, px, py, pz);
        //     position.needsUpdate = true;
        // }
        this.earth.setVisible(false);
        let goldParticles = this.earth.goldParticles;
        goldParticles.geometry.setDrawRange(0, 500);
        let range = {
            r: 500
        };
        return new Promise((resolve, reject) => {
            var tween = new TWEEN.Tween(range).to({
                r: goldParticles.geometry.attributes.position.count
            }, 3000)
                .onUpdate(() => {
                    this.earth.goldParticles.geometry.setDrawRange(0, range.r);
                })
                .onStart(() => {
                    // this.earth.changeColor(0xefdb6a);
                    this.earth.changeColor(colorUtil.colorStr2Hex(`#${this.theme.flyParticles}`));
                })
                .start()
                .onComplete(async () => {
                    this.controls.autoRotate = true;
                    this.nodesChild.parent.visible = false;
                    this.earth.setPointedVisible(false);
                    this.camera.position.x = 0;
                    this.flyDiffuse = true;
                    this.flyTween = false;
                    this.clock = new THREE.Clock();
                    await $sleep(500);
                    resolve();
                    TWEEN.remove(tween);
                    tween = null;
                });
        });
    }

    changeNodesOpacity(opacity) {
        let nodes = this.nodesChild.parent.children;
        for (let i = 0; i < nodes.length; i++) {
            this.darkObj(nodes[i], opacity);
        }
    }

    darkObj(child, opacity) {
        if (child.children.length) {
            for (let i = 0; i < child.children.length; i++) {
                this.darkObj(child.children[i], opacity);
            }
        } else {
            if (child.material) {
                child.material.opacity = opacity;
            }
        }
    }

    hideGoldParticle() {
        this.earth.goldParticles.visible = false;
        // this.earth.changeColor(0x00b0f2);
        this.earth.changeColor(colorUtil.colorStr2Hex(`#${this.theme.mainColor}`));
        this.earth.setVisible(true);
        this.nodesChild.parent.visible = true;
    }

    flyParticlesDiffuse() {
        if (!this.earth) {
            TWEEN.remove(this.flyParticleTween);
            this.flyParticleTween = null;
            return;
        }
        let delta = 10 * this.clock.getDelta();
        let speed = 0.1;
        let total = this.earth.goldParticles.geometry.attributes.position.count;
        let position = this.earth.goldParticles.geometry.attributes.position;
        for (let j = 0; j < total; j++) {
            let px = position.getX(j);
            let py = position.getY(j);
            let pz = position.getZ(j);

            let to = new THREE.Vector3(px, py, pz).setLength(20);

            let x = px + to.x * speed * delta;
            let y = py + to.y * speed * delta;
            let z = 0;
            // let dx = Math.abs(to.x - px);
            // let dy = Math.abs(to.y - px);
            // let dz = Math.abs(to.z - pz);
            // let x = px + (to.x - px) / dx * speed * delta;
            // let y = py + (to.y - py) / dy * speed * delta;
            // let z = pz > 0 ? pz + Math.abs(to.z) * speed * delta : 2 * Math.abs(pz + to.z * speed * delta);

            position.setXYZ(j, x, y, z);
            position.needsUpdate = true;
        }
        if (!this.flyTween) {
            this.flyTween = true;
            let count = {
                n: 0
            };
            this.flyParticleTween = new TWEEN.Tween(count)
                .to({ n: total }, 800)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(() => {
                    this.earth.goldParticles.geometry.setDrawRange(count.n, total - count.n);
                })
                .onComplete(() => {
                    this.flyDiffuse = false;
                })
                .start();
        }
    }

    destroyed() {
        TWEEN.remove(this.moonTweenA);
        this.moonTweenA = null;
        // cancelAnimationFrame(this.requestAnimation);
        this.Graph = null;
        window.removeEventListener('resize', () => { });
        let children = [].concat(this.scene.children);
        console.log('children', children);
        if (this.earth) {
            this.earth.depose();
            this.earth = null;
        }

        for (let i = 0; i < children.length; i++) {
            this.disposeThreeObj(children[i], this.scene);
            this.scene.remove(children[i]);
            children[i] = null;
        }
        children = null;
        this.renderer.dispose();
        window.camera = this.camera = null;
        window.renderer = this.renderer = null;
        window.controls = this.controls = null;
        window.THREE.FlyControls = null;

    }
    disposeThreeObj(child, parent) {
        if (child.children.length) {
            for (let i = 0; i < child.children.length; i++) {
                this.disposeThreeObj(child.children[i], child);
            }

        } else {
            parent.remove(child);
            if (child.geometry) {
                child.geometry.dispose();
            }
            if (child.material) {
                child.material.dispose();
            }
            if (child.map) {
                child.map.dispose();
            }
            child = null;
        }
    }

    // 初始化
    initGraph3d() {
        this.counter = 0;
        let { width, height } = this.dom.getBoundingClientRect();
        this.Graph
            .showNavInfo(false)
            .width(width)
            .height(height)
            .backgroundColor('#000000')
            .graphData(this.data)
            .nodeLabel('name')
            .onEngineTick(() => {
                this.counter++;
                // if (this.counter < 100) {
                //     // 计算到（0，0，0）之间距离最大的点
                //     let maxLen = 0;
                //     for (let i = 0; i < this.data.nodes.length; i++) {
                //         let x = Math.pow(this.data.nodes[i].x, 2);
                //         let y = Math.pow(this.data.nodes[i].y, 2);
                //         let z = Math.pow(this.data.nodes[i].z, 2);
                //         let dist = Math.sqrt(x + y + z);

                //         if (dist > maxLen) {
                //             maxLen = dist;
                //         }
                //     }
                //     let vFOV = THREE.Math.degToRad(this.camera.fov);
                //     // 力导图默认在镜头1000位置的视角高度为半径进行扩散，其半径为sHeight 466.307，
                //     // 多余的节点就会显示在屏幕之外
                //     let sHeight = Math.tan(vFOV / 2) * 1000;
                //     if (this.earth && maxLen > sHeight) {
                //         // 先放大，后拉镜头，保证屏幕大小一致
                //         maxLen += 20;
                //         this.earth.setScale(maxLen);
                //         // 镜头在1200的位置是最好的， 相同视角下，求镜头z的大小，以此为标准，求相似
                //         this.camera.position.z = maxLen * 1200 / sHeight;
                //         this.eventBus.$emit('move-camera', this.camera.position.z);
                //     }
                // }
                // if (this.counter > 72 && this.counter <= 100) {
                //     this.eventBus.$emit('show-3d-scene', this.counter - 70);
                // }
                if (this.counter === 10) {
                    this.eventBus.$emit('show-3d-scene');
                }
            });
        // .nodeAutoColorBy('group')
        // .nodeOpacity(.75)
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setClearAlpha(0);
    }

    initLink() {
        this.Graph
            .linkOpacity(0.8)
            .linkWidth(1)
            .linkColor(() => `#${this.theme.mainColor}` || '#00b0f2');
    }

    initForce() {
        this.Graph
        // .warmupTicks(3)
        // .d3AlphaDecay(0.05)
    }

    initEvent() {
        this.Graph
            .onNodeHover(node => {
                // console.log(node);
                this.dom.style.cursor = node ? 'pointer' : null;
            })
            .onNodeClick((node) => {
                // console.log('click', node, node.depth);
                if (node.depth === '0') {
                    node.fx = undefined;
                    node.fy = undefined;
                    node.fz = undefined;
                }
                this.cutToNode(node);
            });
    }

    stopAnimate() {
        cancelAnimationFrame(this.requestAnimation);
        this.Graph.pauseAnimation();
    }

    resumeAnimation() {
        this.render();
        this.changeNodesOpacity(1);
        this.earth.setPointedVisible(true);
        this.Graph.resumeAnimation();
    }

    render() {
        // get the frame
        this.requestAnimation = requestAnimationFrame(this.render.bind(this));
        // render the scene
        if (this.renderer && this.controls && this.camera) {
            this.renderer.render(this.scene, this.camera);
            this.controls.update();
            this.camera.updateProjectionMatrix();
        }
        TWEEN.update();
        if (this.earth) {
            this.earth.update();
        }
        if (this.flyDiffuse) {
            this.flyParticlesDiffuse();
        }
    }
};

export default graph3d;
